

export const index = 0;
let component_cache;
export const component = async () => component_cache ??= (await import('../entries/pages/_layout.svelte.js')).default;
export const imports = ["_app/immutable/nodes/0.C2L4iL9K.js","_app/immutable/chunks/DowcGjab.js","_app/immutable/chunks/BzCi4Of2.js","_app/immutable/chunks/DtZr5J-4.js"];
export const stylesheets = [];
export const fonts = [];
